<template>
    <sweet-modal icon="warning" ref="deleteSeriesModal" @close="$emit('modal-close')">
        <div v-if="selected !== null" class="text-center">
            <p class="mt-3" v-html="$t('pages.admin.series.delete_confirmation', {title: selected.title[$i18n.locale]})"></p>
            <button class="btn btn-danger" @click="deleteSelected">
                {{ $t('actions.delete') }}
            </button>
        </div>
    </sweet-modal>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue'
import AdminSeriesRepository from "../../../repositories/Admin/AdminSeriesRepository";
export default {
    name: "SeriesDeleteModal",
    components: {SweetModal},
    props: {
        selected: {
            type: Object,
            default: null
        }
    },
    methods: {
        deleteSelected() {
            AdminSeriesRepository
                .deleteSeries(this.selected.slug)
                .then((res) => {
                    this.$emit('series-deleted');
                    this.$refs.deleteSeriesModal.close();
                });
        }
    },
    watch: {
        selected: function (val) {
            if(val !== null)
                this.$refs.deleteSeriesModal.open();
        }
    }
}
</script>

<style scoped>

</style>
